import { ArrowLeft } from 'lucide-react';
import {
  Labeled,
  Pagination,
  ReferenceManyField,
  WithListContext,
} from 'react-admin';
import { useTranslate } from 'ra-core';
import NegotiationCard from './NegotiationCard';
import { Negotiation } from '../types';
import { Button } from '@/components/ui/button';

function NegotiationHistory({ onClose }: { onClose: () => void }) {
  const t = useTranslate();

  return (
    <div>
      <Labeled
        label={
          <span className="flex flex-row items-center gap-2 mb-2">
            <Button variant="ghost" size="icon" onClick={onClose}>
              <ArrowLeft className="size-4" />
            </Button>
            <span>{t('common.text.negotiation_history')}</span>
          </span>
        }
      >
        <ReferenceManyField
          reference="offer-negotiations"
          target="offer_id"
          perPage={25}
          pagination={<Pagination />}
          sort={{ field: 'created_at', order: 'DESC' }}
        >
          <WithListContext<Negotiation>
            render={({ data: negotiations, isPending }) => {
              if (isPending)
                return (
                  <div className="h-1 w-full overflow-hidden rounded-full bg-border">
                    <div className="h-full w-1/2 bg-primary/70 animate-pulse rounded-full" />
                  </div>
                );
              if (!negotiations) return <div>No negotiations available</div>;

              return (
                <div className="grid gap-4">
                  {negotiations.map(negotiation => (
                    <NegotiationCard
                      key={negotiation.id}
                      negotiation={negotiation}
                    />
                  ))}
                </div>
              );
            }}
          />
        </ReferenceManyField>
      </Labeled>
    </div>
  );
}

export default NegotiationHistory;
